import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { createPortal } from "react-dom";
import { getervaringen, savebeschikbaarheid, getbeschikbaarheid, updatebeschikbaarheid, getervaringenall, setalledagen } from "../Reducers/actions";
import { message, fixmessage } from "../../../Reducers/loading/actions";
import Bar from "../Components/bar";
import Beschikbaarheidtabel from "../Components/bschikbaarheidtabel";
import BeschikbaarheidForm from "../Components/beschikbaarheidform";
import Beschikbaarheideditform from "../Components/beschikbaarheideditform";
import Modal from "../../../Components/Modal";
import Loading from "../../../Components/loading/load";
import { useParams } from "react-router-dom";

const BeschikbaarheidPage = ({ getervaringen, alledagen, setalledagen, ervaring, fixmessage, message, boekingen, savebeschikbaarheid, getbeschikbaarheid, beschikbaarheid, updatebeschikbaarheid, getervaringenall }) => {
  const [loaded, setLoaded] = useState(false);
  const [visible, setVisible] = useState(false);
  const [visibleedit, setVisibleedit] = useState(false);
  const params = useParams();
  const submit = (vals) => {
    vals.ervaring = params.id;
    vals.beschikbaarheid = ervaring.beschikbaarheid;
    vals.location = ervaring.location;
    vals.prijzen = ervaring.prijzen;
    vals.betaald = ervaring.betaald;
    savebeschikbaarheid(vals).then((data) => {
      if (!data.results) {
             message(3000, "danger", data.payload.error.msg);
      } else {
        message(3000, "success", "De beschikbaarheid is succesvol toegevoegd").then((data) => {});
        loadervaringen();
        setVisible(false);
      }
    });
  };

  const update = (vals) => {
    updatebeschikbaarheid(vals._id, vals).then((data) => {
      if (!data.results) {
        message(3000, "danger",  data.payload.error.msg);
      } else {
        message(3000, "success", "De beschikbaarheid is succesvol gewijzigd").then((data) => {});
        loadervaringen();
        setVisibleedit(false);
      }
    });
  };


  useEffect(() => {
    if (alledagen) {
      getervaringenall(params.id).then((sdata) => {
        if (sdata.results) {
          setLoaded(true);
        }
      });
    } else {
      loadervaringen();
    }
  }, [alledagen]);

  const loadervaringen = () => {
    getervaringen(params.id).then((sdata) => {
      if (sdata.results) {
        setLoaded(true);
      }
    });
  };

  const loadbeschikbaarheid = (id) => {
    setVisibleedit(false);
    getbeschikbaarheid(id).then((sdata) => {
      if (sdata.results) {
        setTimeout(() => {
          setVisibleedit(true);
        }, 100); // 1000 milliseconden = 1 seconde
      }
    });
  };

  return (
    <React.Fragment>
      <Loading loadings={loaded} />
      {loaded && (
        <div className="box box-default">
          <div className="box-header with-border">
            <div className="box-title">
              <h2>{ervaring.naam}</h2>
            </div>
            <div className="box-tools pull-right">
              <button onClick={() => setVisible(true)} className="btn btn-primary btn-sm float-right" role="group">
                Beschikbaarheid toevoegen
              </button>
              <button onClick={() => setalledagen(!alledagen)} className="mx-2 btn btn-sm btn-info btn-sm float-right" role="group">
                {alledagen ? "Toekomstige dagen" : "Alle dagen"}
              </button>
            </div>
          </div>
          {createPortal(
            <Modal visible={visible} onClose={() => setVisible(false)} width={600}>
              <div className="box box-default">
                <div className="box-title">
                  <h3>Beschikbaarheid toevoegen</h3>
                </div>
                <BeschikbaarheidForm ervaring={ervaring} onSubmit={submit} />
              </div>
            </Modal>,
            document.body
          )}

          {createPortal(
            <Modal visible={visibleedit} onClose={() => setVisibleedit(false)} width={600}>
              <div className="box box-default">
                <div className="box-title">
                  <h3>Beschikbaarheid wijzigen</h3>
                </div>
                {visibleedit && <Beschikbaarheideditform beschikbaarheid={beschikbaarheid} onSubmit={update} />}
              </div>
            </Modal>,
            document.body
          )}

          <div className="box-body box-profile">
            <div>
              <Bar ervaring={ervaring} boekingen={boekingen} />
            </div>
            <div className="box-body">
              <Beschikbaarheidtabel loadbeschikbaarheid={loadbeschikbaarheid} beschikbaarheid={ervaring.ervaringdatums} />
            </div>
          </div>
        </div>
      )}
    </React.Fragment>
  );
};
function mapStateToProps(state) {
  return { username: state.auth.user, ervaring: state.ervaringen.item, boekingen: state.boekingen.items, beschikbaarheid: state.ervaringen.beschikbaarheid, alledagen: state.ervaringen.alledagen };
}

export default connect(mapStateToProps, {
  message,
  fixmessage,
  getervaringen,
  savebeschikbaarheid,
  getbeschikbaarheid,
  updatebeschikbaarheid,
  getervaringenall,
  setalledagen,
})(BeschikbaarheidPage);
